import { useJwt } from '../services/jwt.service';
import axios from 'axios';
import { API_URL } from '../constants/api.constant';
const urljoin = require('url-join');

const authAxios = useJwt.getAuthenticatedInterceptor(); // Use authenticated axios for authenticated requests


export const API = {

    // AUTHENTICATION
    LOGIN: (...args) => axios.post(API_URL.AUTH_LOGIN, ...args),
    REGISTER: (...args) => axios.put(API_URL.AUTH_REGISTER, ...args),
    PROFILE: (...args) => authAxios.get(API_URL.USER_PROFILE, ...args),
    PROFILEUPDATE: (...args) => authAxios.post(API_URL.USER_PROFILE, ...args),

    // USER SUBSCRIPTION
    GET_USERLIST: (...args) => authAxios.get(API_URL.GET_USERLIST, ...args),
    GET_USER: (id = '', ...args) => authAxios.get(urljoin(API_URL.GET_USERLIST, id), ...args),
    UPDATE_USER: (id = '', ...args) => authAxios.post(urljoin(API_URL.GET_USERLIST, id), ...args),
    GET_SUBSCRIPTION: (...args) => authAxios.get(API_URL.GET_SUBSCRIPTION, ...args),
    ADD_SUBSCRIPTION_DEVICE: (...args) => authAxios.post(API_URL.ADD_SUBSCRIPTION, ...args),
    REMOVE_SUBSCRIPTION_DEVICE: (id, ...args) => authAxios.post(API_URL.REMOVE_SUBSCRIPTION(id), ...args),
    // USER MEMBERSHIP
    MY_MEMBERSHIP: (...args) => authAxios.get(API_URL.MY_MEMBERSHIP, ...args),
    MY_PLANS: (...args) => authAxios.get(API_URL.MY_PLANS, ...args),
    BUY_MEMBERSHIP: (...args) => authAxios.post(API_URL.BUY_MEMBERSHIP, ...args),
    // ADD_SUBSCRIPTION_DEVICE: (...args) => authAxios.post(API_URL.ADD_SUBSCRIPTION, ...args),
    // REMOVE_SUBSCRIPTION_DEVICE: (id, ...args) => authAxios.post(API_URL.REMOVE_SUBSCRIPTION(id), ...args),

    // BULLETIN
    GET_BULLETIN: (...args) => authAxios.get(API_URL.BULLETIN, ...args),
    GET_BULLETIN_BY_ID: (id = '', ...args) => authAxios.get(urljoin(API_URL.BULLETIN, id)),
    PUT_BULLETIN: (...args) => authAxios.put(API_URL.BULLETIN, ...args),
    POST_BULLETIN_BY_ID: (id = '', ...args) => authAxios.post(urljoin(API_URL.BULLETIN, id), ...args),

    // UPLOAD_FILE
    // UPLOAD_FILE: (...args) => authAxios.put(API_URL.UPLOAD_FILE, ...args),
    UPLOAD_FILE: (progressUpdate, ...args) => authAxios.put(API_URL.UPLOAD_FILE, ...args, { onUploadProgress: progressUpdate }),

    // GRIEVANCE
    PUT_GRIEVANCE: (...args) => authAxios.put(API_URL.GRIEVANCE, ...args),
    GET_ALL_GRIEVANCES: (...args) => authAxios.get(API_URL.GRIEVANCE, ...args),
    GET_GRIEVANCE: (id = '', ...args) => authAxios.get(urljoin(API_URL.GRIEVANCE, id), ...args),
    ACK_GRIEVANCE: (id = '', ...args) => authAxios.post(urljoin(API_URL.GRIEVANCE, id, '/acknowledge'), ...args),

    //  PAYMENT 
    PAYMENT: (...args) => authAxios.post(API_URL.PAYMENT, ...args),

    // LATEST NEWS
    LATEST_NEWS: (...args) => authAxios.get(API_URL.LATEST_NEWS, ...args),

    // MEMBERS
    MEMBERS: (...args) => authAxios.get(API_URL.MEMBERS, ...args),

    // DOCUMENTS

    LETTER: (id = '', ...args) => authAxios.get(urljoin(API_URL.DOCUMENTS.LETTER, id), ...args),
    CIRCULAR: (id = '', ...args) => authAxios.get(urljoin(API_URL.DOCUMENTS.CIRCULAR, id), ...args),
    DIRECTIVE: (id = '', ...args) => authAxios.get(urljoin(API_URL.DOCUMENTS.DIRECTIVE, id), ...args),
    FLIGHT_SAFETY: (id = '', ...args) => authAxios.get(urljoin(API_URL.DOCUMENTS.FLIGHT_SAFETY, id), ...args),
    MISCELANEOUS: (id = '', ...args) => authAxios.get(urljoin(API_URL.DOCUMENTS.MISCELLANEOUS, id), ...args),
    UPDATE_LETTER: (id = '', ...args) => authAxios.post(urljoin(API_URL.DOCUMENTS.LETTER, id), ...args),
    UPDATE_CIRCULAR: (id = '', ...args) => authAxios.post(urljoin(API_URL.DOCUMENTS.CIRCULAR, id), ...args),
    UPDATE_DIRECTIVE: (id = '', ...args) => authAxios.post(urljoin(API_URL.DOCUMENTS.DIRECTIVE, id), ...args),
    UPDATE_FLIGHT_SAFETY: (id = '', ...args) => authAxios.post(urljoin(API_URL.DOCUMENTS.FLIGHT_SAFETY, id), ...args),
    UPDATE_MISCELANEOUS: (id = '', ...args) => authAxios.post(urljoin(API_URL.DOCUMENTS.MISCELLANEOUS, id), ...args),
    DELETE_LETTER: (id = '', ...args) => authAxios.delete(urljoin(API_URL.DOCUMENTS.LETTER, id), ...args),
    DELETE_CIRCULAR: (id = '', ...args) => authAxios.delete(urljoin(API_URL.DOCUMENTS.CIRCULAR, id), ...args),
    DELETE_DIRECTIVE: (id = '', ...args) => authAxios.delete(urljoin(API_URL.DOCUMENTS.DIRECTIVE, id), ...args),
    DELETE_FLIGHT_SAFETY: (id = '', ...args) => authAxios.delete(urljoin(API_URL.DOCUMENTS.FLIGHT_SAFETY, id), ...args),
    DELETE_MISCELANEOUS: (id = '', ...args) => authAxios.delete(urljoin(API_URL.DOCUMENTS.MISCELLANEOUS, id), ...args),
    GET_LETTERS: (...args) => authAxios.get(API_URL.DOCUMENTS.LETTER, ...args),
    GET_CIRCULARS: (...args) => authAxios.get(API_URL.DOCUMENTS.CIRCULAR, ...args),
    GET_DIRECTIVES: (...args) => authAxios.get(API_URL.DOCUMENTS.DIRECTIVE, ...args),
    GET_FLIGHT_SAFETY: (...args) => authAxios.get(API_URL.DOCUMENTS.FLIGHT_SAFETY, ...args),
    GET_MISCELANEOUS: (...args) => authAxios.get(API_URL.DOCUMENTS.MISCELLANEOUS, ...args),
    PUT_LETTERS: (...args) => authAxios.put(API_URL.DOCUMENTS.LETTER, ...args),
    PUT_CIRCULARS: (...args) => authAxios.put(API_URL.DOCUMENTS.CIRCULAR, ...args),
    PUT_DIRECTIVES: (...args) => authAxios.put(API_URL.DOCUMENTS.DIRECTIVE, ...args),
    PUT_FLIGHT_SAFETY: (...args) => authAxios.put(API_URL.DOCUMENTS.FLIGHT_SAFETY, ...args),
    PUT_MISCELANEOUS: (...args) => authAxios.put(API_URL.DOCUMENTS.MISCELLANEOUS, ...args),

    // SCHEMES
    TMU: (...args) => authAxios.post(API_URL.SCHEMES.TMU, ...args),
    PMU: (...args) => authAxios.post(API_URL.SCHEMES.PMU, ...args),
    INCIDENT: (...args) => authAxios.post(API_URL.SCHEMES.INCIDENT, ...args),
    ACCIDENT: (...args) => authAxios.post(API_URL.SCHEMES.ACCIDENT, ...args),
    ADMIN: (...args) => authAxios.post(API_URL.SCHEMES.ADMIN, ...args),
    SCHEMES: (...args) => authAxios.get(API_URL.SCHEMES.GET_ALL, ...args),
    // SCHEMES: (...args) => authAxios.get(API_URL.SCHEMES.GET_ALL, ...args),
    GMCINDIPDF: (id = '', ...args) => authAxios.get(urljoin(API_URL.SCHEMES.GET_GMCINDI_PDF, id), ...args, { responseType: 'blob' }),
    GETALL_GMC: (...args) => authAxios.get(API_URL.SCHEMES.GET_GMC_ALL, ...args),
    GMCCSV: (...args) => authAxios.get(API_URL.SCHEMES.GET_GMCCSV, ...args, { responseType: 'blob' }),
    GMCPDF: (...args) => authAxios.get(API_URL.SCHEMES.GET_GMCPDF, ...args, { responseType: 'blob' }),
    GET_SCHEME: (id = '', ...args) => authAxios.get(urljoin(API_URL.SCHEMES.GET_MY_SCHEME, id), ...args),

    //COMMON SCHEMES
    CREATE_MHW: (...args) => authAxios.post(API_URL.SCHEMES.MHW_SCHEME, ...args)
}